import type { useTranslations } from "@i18n/next";
import { USERNAME_MAX_CHARS, USERNAME_MIN_CHARS } from "@packages/sdk";

export const usernameErrorMap = (
  t: ReturnType<typeof useTranslations>,
  err: string,
) => {
  if (err === "web_username_validation_error_invalid_length") {
    return t(err, {
      0: USERNAME_MIN_CHARS,
      1: USERNAME_MAX_CHARS,
    });
  }
  return t(err);
};
